export const formSchema = [
    {
        label: "销方名称",
        selected: true,
        default: false,
        name: "saleName",
    },
    {
        label: "销方税号",
        selected: true,
        default: false,
        name: "saleCreditCode",
    },
    {
        label: "购方名称/信用代码",
        selected: true,
        default: false,
        name: "custNameAndCreditCode",
    },
    {
        label: "发票种类",
        selected: true,
        default: false,
        name: "invType",
        type: "dict",
        dict: "inv_type",
    },
    {
        label: "单据编号",
        selected: true,
        default: false,
        name: "billCode",
    },
    {
        label: "开票方式",
        selected: true,
        default: false,
        name: "manageType",
        type: "dict",
        dict: "manage_type",
        
    },
    {
        label: "数据来源",
        selected: true,
        default: false,
        name: "billSource",
        type: "dict",
        dict: "bill_source",
    },
    {
        label: "事业部",
        selected: true,
        default: false,
        name: "departmentNo",
        type: "dict",
        dict: "department_no",
    },
    {
        label: "所属区域",
        selected: true,
        default: false,
        name: "regionNo",
        type: "dict",
        dict: "region_no",
    },
    {
        label: "主管税局省市",
        selected: true,
        default: false,
        name: "taxBureauId",
        type: "dict",
        dict: "taxBureau_id",
    },
    {
        label: "异常类型",
        selected: true,
        default: false,
        name: "opType",
        type: "dict",
        dict: "BELLE_OP_TYPE",
    },
    {
        label: "税率", 
        selected: true,
        default: false,
        name: "taxRate",
        type: "dict",
        dict: "ovat_tax_rate",
    },
    {
        label: "开票日期",
        selected: true,
        default: false, 
        name: "invoiceDate",
        type: "date",
    },
    {
        label: "申请日期",
        selected: true,
        default: false,
        name: "applyDate",
        type: "date",
    },
    {
        label: "城市",
        selected: true,
        default: false,
        name: "cityName",
    },
    {
        label: "异常原因",
        selected: true,
        default: false,
        name: "errorMsg",
    },
    {
        label: "全电发票标识",
        selected: true,
        default: false,
        name: "fullEleInvoiceFlag",
        type: "dict",
        dict: "full_ele_invoice_flag",
    },
    {
        label: "全电导出状态",
        selected: true,
        default: false,
        name: "fullEleExportStatus",
        type: "dict",
        dict: "full_ele_export_status",
    },
];

export const columns = [
    {
        label: "异常原因",
        selected: true,
        default: false,
        name: "errorMsg",
    },
    {
        label: "异常类型",
        selected: true,
        default: false,
        name: "opType",
        type: "dict",
        dict: "BELLE_OP_TYPE",
    },
    {
        label: "单据编号",
        selected: true,
        default: false,
        name: "billCode",
    },
    {
        label: "发票种类",
        selected: true,
        default: false,
        name: "invType",
        type: "dict",
        dict: "inv_type",
    },
    {
        label: "销方名称",
        selected: true,
        default: false,
        name: "saleName",
    },
    {
        label: "销方税号",
        selected: true,
        default: false,
        name: "saleCreditCode",
    },
    {
        label: "购方名称",
        selected: true,
        default: false,
        name: "custName",
    },
    {
        label: "购方信用代码",
        selected: true,
        default: false,
        name: "custCreditCode",
    },
    {
        label: "购方地址电话",
        selected: true,
        default: false,
        name: "custAddress",
    },
    {
        label: "购方银行账号",
        selected: true,
        default: false,
        name: "custBank",
    },
    {
        label: "申请日期",
        selected: true,
        default: false,
        name: "applyDate",
    },
    {
        label: "开票方式",
        selected: true,
        default: false,
        name: "manageType",
        type: "dict",
        dict: "manage_type",
    },
    {
        label: "开票点",
        selected: true,
        default: false,
        name: "ukeyId",
        type: "dict",
        dict: "ukey_id",
    },
    {
        label: "数据来源",
        selected: true,
        default: false,
        name: "billSource",
        type: "dict",
        dict: "invoice_source",
    },
    {
        label: "事业部",
        selected: true,
        default: false,
        name: "departmentNo",
        type: "dict",
        dict: "department_no",
    },
    {
        label: "所属区域",
        selected: true,
        default: false,
        name: "regionNo",
        type: "dict",
        dict: "region_no",
    },
    {
        label: "主管税局省市",
        selected: true,
        default: false,
        name: "taxBuName",
    },
    {
        label: "合计金额",
        selected: true,
        default: false,
        name: "totalAmt",
        type: "number",
    },
    {
        label: "合计税额",
        selected: true,
        default: false,
        name: "totalTaxamt",
        type: "number",
    },
    {
        label: "价税合计",
        selected: true,
        default: false,
        name: "adValoremTotal",
        type: "number",
    },
    {
        label: "备注",
        selected: true,
        default: false,
        name: "remark",
    },
    {
        label: "清单标志",
        selected: true,
        default: false,
        name: "isList",
        type: "dict",
        dict: "is_list",
    },
    {
        label: "发票代码",
        selected: true,
        default: false,
        name: "invoiceCode",
    },
    {
        label: "发票号码",
        selected: true,
        default: false,
        name: "invoiceNumber",
    },
    {
        label: "邮箱",
        selected: true,
        default: false,
        name: "custEmail",
    },
    {
        label: "手机号",
        selected: true,
        default: false,
        name: "custMobile",
    },
    {
        label: "税率", 
        selected: true,
        default: false,
        name: "taxRate",
        type: "dict",
        dict: "ovat_tax_rate",
    },
    {
        label: "开票日期",
        selected: true,
        default: false,
        name: "invoiceDate",
    },
    {
        label: "城市",
        selected: true,
        default: false,
        name: "cityName",
    },
    {
        label: "全电发票标识",
        selected: true,
        default: false,
        name: "fullEleInvoiceFlag",
        type: "dict",
        dict: "full_ele_invoice_flag",
    },
    {
        label: "全电导出状态",
        selected: true,
        default: false,
        name: "fullEleExportStatus",
        type: "dict",
        dict: "full_ele_export_status",
    },
    {
        label: "全电导出时间",
        selected: true,
        default: false,
        name: "fullEleExportTime",
    },
];

export const version = 2.1;
export const profileType = "156";



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoiceException/config.js